/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyIdentityFinancingMigrationResponse
 */
export interface CompanyIdentityFinancingMigrationResponse {
    /**
     * Number of CompanyIdentityFinancingMigrationRequested events fired
     * @type {number}
     * @memberof CompanyIdentityFinancingMigrationResponse
     */
    firedEvents: number;
}

/**
 * Check if a given object implements the CompanyIdentityFinancingMigrationResponse interface.
 */
export function instanceOfCompanyIdentityFinancingMigrationResponse(value: object): value is CompanyIdentityFinancingMigrationResponse {
    if (!('firedEvents' in value) || value['firedEvents'] === undefined) return false;
    return true;
}

export function CompanyIdentityFinancingMigrationResponseFromJSON(json: any): CompanyIdentityFinancingMigrationResponse {
    return CompanyIdentityFinancingMigrationResponseFromJSONTyped(json, false);
}

export function CompanyIdentityFinancingMigrationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyIdentityFinancingMigrationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'firedEvents': json['firedEvents'],
    };
}

export function CompanyIdentityFinancingMigrationResponseToJSON(value?: CompanyIdentityFinancingMigrationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firedEvents': value['firedEvents'],
    };
}

